/**
 *
 */
import * as React from 'react';
import {observer} from "mobx-react";
import {IResDay} from "shared/ResDay";
import {computed} from "mobx";
import {TimeSlot} from "components/reservations/TimeSlot";
import {IReservation} from "shared/IReservation";
import {DateTime} from "luxon";

import './AvailableSlots.pcss';
import {DateTimeFormat, DateTimeHelpers} from "shared/DateTimeHelpers";
import {ResData} from "components/reservations/ResData";
import {NoSlotsAvailable} from "components/reservations/NoSlotsAvailable";

interface Props {
  resDay:IResDay;
  hasPrevious:boolean;
  hasNext:boolean;
  onGoPrevious:()=>void;
  onGoNext:()=>void;
  onClickSlot:(slot:DateTime)=>void;
  reservationToReschedule:IReservation|null;
  slotsAlreadyReserved:DateTime[];
  timezone:string;
  uiWordSlot:string;
}

@observer
export class AvailableSlots extends React.Component<Props> {

  @computed get slots() {
    return ResData.availableSlotsForResDay(this.props.resDay);
  }

  @computed get isMultiDay() {
    return this.props.hasPrevious || this.props.hasNext;
  }

  render() {

    return (
      <div className={"available-slots"}>

        {this.isMultiDay &&
          <div className={"available-slots-day-nav"}>

            <div>
                {this.props.hasPrevious ?
                  <button onClick={this.props.onGoPrevious}>
                    <span aria-hidden="true" className={"material-icons"}>arrow_back_ios</span>
                    <span className="visuallyhidden">Go to previous day</span>
                  </button>
                  :
                  <button className="disabled" aria-hidden="true"><span aria-hidden="true" className={"material-icons"}>arrow_back_ios</span></button>
                }
            </div>
            <div>
              <h2>{DateTimeHelpers.format(this.props.resDay.day, DateTimeFormat.WEEKDAY_ABREV_MMDD_UI, "America/New_York")}</h2>
            </div>
            <div>
                {this.props.hasNext ?
                  <button onClick={this.props.onGoNext}>
                    <span aria-hidden="true" className={"material-icons"}>arrow_forward_ios</span>
                    <span className="visuallyhidden">Go to next day</span>
                  </button>
                  :
                  <button className="disabled" aria-hidden="true"><span aria-hidden="true" className={"material-icons"}>arrow_forward_ios</span></button>
                }
            </div>

        </div>
        }

        {!this.isMultiDay &&
          <div className={"available-slots-single-day"}>
            <h2>{DateTimeHelpers.format(this.props.resDay.day, DateTimeFormat.WEEKDAY_MMDD_UI, "America/New_York")}</h2>
          </div>
        }

        {0!==this.slots.length &&
        <div className={"available-slots-times"}>
          {this.slots.map(slot => <TimeSlot key={slot.toMillis()} timezone={this.props.timezone} slot={slot} slotsAlreadyReserved={this.props.slotsAlreadyReserved} onClick={this.props.onClickSlot} />)}
        </div>
        }

        {0===this.slots.length &&
          <NoSlotsAvailable uiWordSlot={this.props.uiWordSlot} />
        }

        <div className={"available-slots-timezone"}>
          Times are displayed in&nbsp;{DateTimeHelpers.format(DateTime.now(), DateTimeFormat.TZ, this.props.timezone)}
        </div>

      </div>
    );
  }

}

